import React, { useState } from 'react';
import parseImages from '../utils/parseImages';

const OpenCallDetailModal = ({ isOpen, onClose, openCalls }) => {
    const [lightboxImage, setLightboxImage] = useState(null);

    const imageArray = parseImages(openCalls?.images);
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-4/5 max-w-3xl shadow-lg max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded-t-lg">
                    <h2 className="text-xl font-bold">Open Call Details</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-600 hover:text-gray-900 text-xl font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Modal Content */}
                <div className="p-6">
                    {/* Profile Section */}
                    {/* <div className="flex mb-6 gap-8">
                        <img src={openCalls.images} alt="banner" className="w-full object-cover mr-4 rounded-lg" />
                    </div> */}
                    <div className="mb-6">

                        {/* SINGLE IMAGE */}
                        {imageArray.length === 1 && (

                            <div
                                className="group relative cursor-pointer overflow-hidden rounded-2xl"
                                onClick={() => setLightboxImage(imageArray[0])}
                            >

                                <img
                                    src={imageArray[0]}
                                    alt="banner"
                                    className="h-[420px] w-full object-cover transition duration-500 group-hover:scale-[1.02]"
                                />

                                {/* DOWNLOAD */}
                                <a
                                    href={imageArray[0]}
                                    download
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => e.stopPropagation()}
                                    className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-black/70 text-white opacity-0 backdrop-blur-md transition group-hover:opacity-100"
                                >
                                    <svg
                                        className="h-5 w-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 5v10m0 0l-4-4m4 4l4-4m-9 8h10"
                                        />
                                    </svg>
                                </a>

                            </div>
                        )}

                        {/* MULTIPLE IMAGES */}
                        {imageArray.length > 1 && (

                            <div className="grid grid-cols-2 gap-3">

                                {imageArray.map((img, index) => (

                                    <div
                                        key={index}
                                        className="group relative cursor-pointer overflow-hidden rounded-2xl"
                                        onClick={() => setLightboxImage(img)}
                                    >

                                        <img
                                            src={img}
                                            alt={`gallery-${index}`}
                                            className="h-[220px] w-full object-cover transition duration-500 group-hover:scale-[1.03]"
                                        />

                                        {/* DOWNLOAD */}
                                        <a
                                            href={img}
                                            download
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                            className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-black/70 text-white opacity-0 backdrop-blur-md transition group-hover:opacity-100"
                                        >
                                            <svg
                                                className="h-4 w-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 5v10m0 0l-4-4m4 4l4-4m-9 8h10"
                                                />
                                            </svg>
                                        </a>

                                    </div>

                                ))}

                            </div>
                        )}

                    </div>
                    <div className="flex mb-6 gap-8">
                        <div>
                            <h3 className="text-2xl font-bold">
                                {openCalls.title}
                                {openCalls.organization_title ? ` (${openCalls.organization_title})` : ""}
                            </h3>
                            <p className="text-gray-600">{openCalls.email}</p>
                            <p className="text-gray-600">{openCalls.phone}</p>
                            <div><strong>Paid Status: </strong>{openCalls.plan_id === 3 ? "Ultimate" : openCalls.plan_id === 2 ? "Pro" : "Free"} </div>
                            <div><strong>Status: </strong> {openCalls.deleted ? "Active" : "Non-Active"}</div>
                            <div><strong>Visibility: </strong> {openCalls.deleted ? "Visible" : "Not Visible"}</div>
                            <div><strong>Total Views: </strong> {openCalls.viewed || "NA"}</div>
                            <button><strong>Apply Now: </strong> <a href={openCalls.apply_now_link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">Click Here</a></button>
                        </div>
                    </div>

                    {/* Event Artistic Fields Section */}
                    <div className="mt-4">
                        <h4 className="text-xl font-semibold mb-2">Event Artistic Fields</h4>
                        <div className="grid grid-cols-1 gap-4">
                            <div><strong>Artistic Fields: </strong> {openCalls.artistic_fields}</div>
                        </div>
                    </div>

                    {/* Event Details Section */}
                    <div className="mt-4">
                        <h4 className="text-xl font-semibold mb-2">Event & Listing Details</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>Gender Allowed: </strong> {openCalls.gender}</div>
                            <div><strong>Industry Type: </strong> {openCalls.industry_type || "NA"}</div>
                            <div><strong>OpenCall Type: </strong> {openCalls.type || "NA"}</div>
                            <div><strong>Category: </strong> {openCalls.category || 'NA'}</div>
                            <div><strong>Eligibility: </strong> {openCalls.eligibility || 'NA'}</div>
                            <div><strong>Not On Profit: </strong> {openCalls.not_on_profit || 'NA'}</div>
                            <div><strong>Fee Type: </strong> {openCalls.fee_type || 'NA'}</div>
                            <div><strong>Price: </strong>  ${openCalls.price}</div>
                            <div><strong>Event Date: </strong> {openCalls.event_date || "NA"}</div>
                            <div><strong>Event Deadline: </strong> {openCalls.event_deadline || "NA"}</div>

                        </div>
                    </div>

                    {/* Social Section */}
                    <div className="mt-6">
                        <h4 className="text-xl font-semibold mb-2">Social Media Links</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>Website: </strong> <a href={openCalls.web_link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">Visit Site</a></div>
                            <div><strong>Instagram: </strong> <a href={openCalls.instagram} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">Open Instagram</a></div>
                            {[2, 3].includes(openCalls.plan_id) && (
                                <>
                                    <div className="col-span-2 mt-4">
                                        <strong>Instagram Promotion Graphic:</strong>

                                        {openCalls.instagram_promotion_graphic ? (
                                            <div className="mt-3">
                                                <a
                                                    href={openCalls.instagram_promotion_graphic}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img
                                                        src={openCalls.instagram_promotion_graphic}
                                                        alt="instagram-promotion"
                                                        className="h-52 rounded-2xl border border-gray-200 object-cover transition hover:scale-[1.01]"
                                                    />
                                                </a>
                                            </div>
                                        ) : (
                                            <span> NA</span>
                                        )}
                                    </div>

                                    <div className="col-span-2">
                                        <strong>Instagram Caption: </strong>
                                        {openCalls.instagram_caption || 'NA'}
                                    </div>

                                    <div className="col-span-2">
                                        <strong>Instagram Hashtags: </strong>
                                        {openCalls.instagram_hashtags || 'NA'}
                                    </div>

                                    <div>
                                        <strong>Instagram Handle: </strong>
                                        {openCalls.instagram_handle || 'NA'}
                                    </div>
                                </>
                            )}

                        </div>
                    </div>

                    {/* Address Section */}
                    <div className="mt-6">
                        <h4 className="text-xl font-semibold mb-2">Event Address</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>City: </strong> {openCalls.city || "NA"}</div>
                            <div><strong>Country: </strong> {openCalls.country || "NA"}</div>
                            <div><strong>Address: </strong> {openCalls.location || "NA"}</div>
                        </div>
                    </div>

                    {/* Prize Details Section */}
                    <div className="mt-6">
                        <h4 className="text-xl font-semibold mb-2">Prize Details</h4>
                        <div className="grid grid-cols-1 gap-4">
                            <div><strong>Prize Summary: </strong> {openCalls.prize_summary || "NA"}</div>
                            <div><strong>Prize Details: </strong> {openCalls.prize_details || "NA"}</div>
                        </div>
                    </div>

                    {/* Description Section */}
                    <div className="mt-6">
                        <div className="relative flex items-center pt-5">
                            <div className="flex-grow border-t border-gray-400"></div>
                            <span className="flex-shrink mx-4 text-gray-400">Description</span>
                            <div className="flex-grow border-t border-gray-400"></div>
                        </div>
                        <div className="mt-4">
                            <p>{openCalls.description}</p>
                        </div>
                    </div>

                    {/* Close Button */}
                    <div className="mt-6 flex justify-end">
                        <button onClick={onClose} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                            Close
                        </button>
                    </div>
                </div>
            </div>

            {/* LIGHTBOX */}
            {lightboxImage && (

                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90 p-4">

                    <button
                        onClick={() => setLightboxImage(null)}
                        className="absolute right-6 top-6 flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-md transition hover:bg-white/20"
                    >
                        ✕
                    </button>

                    <img
                        src={lightboxImage}
                        alt="Preview"
                        className="max-h-[92vh] max-w-[95vw] rounded-2xl object-contain shadow-2xl"
                    />

                </div>
            )}


        </div>
    );
};

export default OpenCallDetailModal;